<template>
  <li
    ref="member"
    @click="organizationMember.role === 'admin' ? modalDeleteAdmin=true : modalDeleteMember=true">
    <p :class="{dtl01: isDR, dtl02: isDH, dtl03: isDA, staff_dtl: true }">{{ userLicenseI18n }}</p>
    <p class="staff_name">{{ userName }}</p>

    <div class="right_dtl">
      <!-- <a
        v-if="organization.has_contract && organizationMember.has_contract === false"
        href="#"
        @click.stop.prevent="modalPremium = true"
      >
        <p class="staff_pay">プレミアム未契約</p>
      </a> -->
      <template v-if="clinic">
        <a
          href="#"
          @click.stop.prevent="modalRole = true"
        >
          <p :class="{ staff_cls: true, cls02: isStaff }">{{ clinicUserRoleI18n }}</p>
        </a>
      </template>

      <!-- START 追加、削除ボタン -->
      <template v-if="mode === 'add'">
        <a @click.stop.prevent="$emit('add', organizationMember, clinicUser)">
          <div class="icon_plus" />
        </a>
      </template>
      <template v-if="mode === 'remove'">
        <a @click.stop.prevent="$emit('remove', organizationMember, clinicUser)">
          <div class="icon_minus" />
        </a>
      </template>
      <!-- END 追加、削除ボタン -->
    </div>

    <!-- 役割モーダル -->
    <front-modal
      :display="modalRole"
      @close="modalRole = false"
    >
      <template slot="title">{{ userName }}さんの役割を選択してください</template>
      <template slot="body">
        <clinic-role-form
          :clinic-user="clinicUser"
          @updated="updatedRole"
        />
      </template>
    </front-modal>

    <!-- プレミアムモーダル -->
    <front-modal
      :display="modalPremium"
      @close="modalPremium = false"
    >
      <template slot="title">プレミアム権限を付与しますか？</template>
      <template slot="body">
        <organization-member-contract-form
          :organization-member="organizationMember"
          @close="modalPremium = false"
          @added="addedContract" />
      </template>
    </front-modal>

    <!-- メンバ削除モーダル -->
    <front-modal
      :display="modalDeleteMember"
      @close="modalDeleteMember = false"
    >
      <template slot="title">{{ userName }}さんをグループメンバから削除しますか？</template>
      <template slot="body">
        <organization-member-delete-form
          :organization-member="organizationMember"
          @close="modalDeleteMember = false"
          @deleted="deletedMember" />
      </template>
    </front-modal>

    <!-- 管理者削除モーダル -->
    <front-modal
      :display="modalDeleteAdmin"
      @close="modalDeleteAdmin = false"
    >
      <template slot="title">{{ userName }}さんは管理者ユーザです。</template>
      <template slot="body">
        管理者ユーザは削除できません。削除できるのはメンバーのみです。
      </template>
    </front-modal>
  </li>
</template>
<script>
  import OrganizationApi from '../../../api/organizations.js'
  import FrontModal from "../modal.vue"
  import ClinicRoleForm from "../clinics/clinic_role_form.vue"
  import OrganizationMemberContractForm from "./organization_member_contract_form.vue"
  import OrganizationMemberDeleteForm from "./organization_member_delete_form.vue"

  export default {
    components: {
      FrontModal,
      ClinicRoleForm,
      OrganizationMemberContractForm,
      OrganizationMemberDeleteForm
    },
    props: {
      clinic: {
        type: Object,
        requires: true,
        default: null
      },
      organization: {
        type: Object,
        requires: true,
        default: null
      },
      member: {
        type: Object,
        requires: true,
        default: null
      },
      mode: {
        type: String,
        requires: true,
        default: 'normal'
      }
    },
    data () {
      return {
        modalRole: false,
        modalPremium: false,
        modalDeleteMember: false,
        modalDeleteAdmin: false,
        isLoading: false
      }
    },
    computed: {
      user: vm => vm.member && vm.member.user,
      userName: vm => vm.member && vm.member.user && vm.member.user.name,
      userLicense: vm => vm.user && vm.user.license,
      userLicenseI18n: vm => vm.user && vm.user.license_i18n,
      isDR: vm => vm.userLicense === 'dentist',
      isDH: vm => vm.userLicense === 'dental_hygienist',
      isDA: vm => vm.userLicense === 'dental_assistant',
      clinicId: vm => vm.clinic && vm.clinic.id,
      clinics: vm => vm.user && vm.user.clinics,
      clinicUser: vm => vm.clinic && vm.user && vm.user.clinic_users.find( u => u.clinic_id === vm.clinicId ),
      clinicUserRole: vm => vm.clinicUser && vm.clinicUser.role,
      clinicUserRoleI18n: vm => vm.clinicUser && vm.clinicUser.role_i18n,
      isStaff: vm => vm.clinicUserRole === 'staff',
      organizationMember: vm => vm.member,
      organizationMemberId: vm => vm.member && vm.member.id,
    },
    methods: {
      update() {
        return OrganizationApi.getOrganizationMember(this.organizationMemberId).then((res) => {
          this.$emit('update', res.data.organization_member)
        })
      },
      deletedMember() {
        this.modalDeleteMember = false
        this.isLoading = false
        this.$refs.member.parentNode.removeChild(this.$refs.member);
      },
      updatedRole() {
        this.isLoading = true
        this.update().finally(() => {
          this.modalRole = false
          this.isLoading = false
        })
      },
      addedContract() {
        this.isLoading = true
        this.update().finally(() => {
          this.modalPremium = false
          this.isLoading = false
          this.$emit('add-contract')
        })
      }
    }
  }
</script>
<style scoped>
</style>
